import FormCheckboxGroup from 'components/form/CheckboxGroup';
import Link from 'components/links/Link';

const options = [
  {label: 'abiraterone (Zytiga)', value: 'PA166123407'}, {label: 'bupropion (Wellbutrin)', value: 'PA448687'},
  {label: 'cinacalcet (Sensipar)', value: 'PA164776671'}, {label: 'duloxetine (Cymbalta)', value: 'PA10066'},
  {label: 'fluoxetine (Prozac)', value: 'PA449673'}, {label: 'mirabegron (Myrbetriq)', value: 'PA166177513'},
  {label: 'paroxetine (Paxil)', value: 'PA450801'}, {label: 'quinidine (Quinidex)', value: 'PA451209'},
  {label: 'rolapitant (Varubi)', value: 'PA166396903'}, {label: 'terbinafine (Lamisil)', value: 'PA451614'},
];

export default function PhenoconversionDrugControl({defaultValue, enabled = false}) {
  const helpText = <span>Phenoconversion information courtesy of <Link href="https://precisionmedicine.ufhealth.org/how-to-interpret-results/phenoconversion-calculator/">PROP&trade; pharmacogenetics calculator</Link> developed by The University of Florida Health Precision Medicine Program (<Link href="/pmid/34231197">PMID: 34231197</Link>).</span>;
  return enabled && (
    <div>
      <h3 className="mt-5 mb-1">Concomitant Medications</h3>
      <p><small>Select medications that the patient is taking. These CYP2D6 inhibitors impact CYP2D6 phenotype (phenoconversion).</small></p>
      <FormCheckboxGroup
        name="drugs"
        label="Choose medications (optional)"
        options={options}
        values={defaultValue}
        className="mb-4"
        help={helpText}
      />
    </div>
  );
}
